import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { reservationSelector } from '../selectors'
import analyticsUtils from '../../../utilities/analyticsUtils'

class ReservationConfirmation extends React.Component {
  componentDidMount = () => {
    analyticsUtils.handleReservationConfirmationView()
  }

  render = () => {
    const { reservation, properties: { content } } = this.props
    let nr = (reservation.reservation_number) ? reservation.reservation_number.toString() : ''
    nr = (nr.endsWith('000')) ? nr.substring(0, nr.length - 3) : nr
    const html = content.replace('%reservation_number%', nr)

    return <div dangerouslySetInnerHTML={{ __html: html }} />
  }
}

ReservationConfirmation.propTypes = {
  properties: PropTypes.object,
  reservation: PropTypes.object
}

const mapState = state => ({
  reservation: reservationSelector(state)
})

export default connect(mapState)(ReservationConfirmation)
